/**
 * @desc 获取登录用户信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/web/sso/getUserModel',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/mock/web/sso/getUserModel',
  });
}
